module.exports = __webpack_public_path__ + "static/about-us-four-cards-2-bec9ac25d90121b0ef2fa3df23606197.png";